export default function waitFor(condition, callback, { interval = 50, attempts = Infinity } = {}) {
  let tries = 0;

  function check() {
    tries += 1;

    if (condition()) {
      callback();
      return;
    }

    if (tries >= attempts) {
      callback(true);
      return;
    }

    setTimeout(check, interval);
  }

  check();
}
